module.exports = "files/background_assets.png";